module.exports = __webpack_public_path__ + "img/option-box-bg.2d3a86fd.png";